import React from "react"
import Box from "../../../components/Box"
import { usesAcnData } from "../../../hooks/use-acn-data"
import SwiperSlider from "../../../components/SwiperSlider"
import { GatsbyImage } from "gatsby-plugin-image"
import Heading from "../../../components/Heading"
import Container from "../../../components/Container"

import  { acn_i18n } from "../../../data/i18n_constants"

const LendersLogo = ({ lang }: { lang: string }) => {
  const acnData = usesAcnData()

  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <Box className="grid items-center w-full grid-cols-1 gap-4 mt-10 md:grid-cols-6">
        <div className="col-span-1 md:col-span-2">
          <Heading
            as="h4"
            className="text-center text-blue-500 md:pt-8 md:text-left"
          >
               {acn_i18n.relation[lang]}
          </Heading>
        </div>
        <div className="col-span-1 md:col-span-4">
          <SwiperSlider
            navigation={false}
            pagination={true}
            slidesPerView={3}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 50,
              },
            }}
            autoplay={{
              delay: 5000,
            }}
            speed={700}
          >
            {acnData?.logos?.nodes.length > 0 &&
              acnData.logos.nodes.map((award: any, idx: any) => (
                <div className="w-32 h-20 ">
                  <GatsbyImage
                    key={idx}
                    className="w-full h-full"
                    objectFit="contain"
                    image={award.image_desktop?.asset?.gatsbyImageData}
                    alt={award.label || ""}
                  />
                </div>
              ))}
          </SwiperSlider>
        </div>
      </Box>
    </Container>
  )
}

export default LendersLogo
